import { useEffect, useState } from 'react';

import { AnchorLink } from 'components/anchorLink';
import { Button } from 'components/button';
import { CountdownTimer } from 'components/countdownTimer';
import { DynamicImage, enLoading } from 'components/Image';
import { IMAGE_COUNTRY } from 'features/ippica/constants';
import { IppicaCorseInPartenzaResponseApi } from 'lib/api/ippica/ippicaCorseResponseApi';
import { convertInCurrencyValueByPrizeInfo } from 'utility/functions';
import { extendedApiIppica } from 'features/api/ippicaApiSlice';
import { format } from 'date-fns';
import { selectElapsedTime } from 'lib/selectors';
import styles from './IppicaInPartenzaItem.module.scss';
import { useAmbienteContext } from 'context/Ambiente';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaInPartenzaItemProps = {
  item: IppicaCorseInPartenzaResponseApi;
};

export const IppicaInPartenzaItem = ({ item }: IppicaInPartenzaItemProps) => {
  const [timeIsEnding, setTimeIsEnding] = useState<boolean>(false);
  const [isTriggering, setIsTriggering] = useState(false);
  const { pathScommessa } = useAmbienteContext();
  const { elapsedTime, minutes, seconds } = useTypedSelector((state) =>
    selectElapsedTime(state[pathScommessa[0]]?.currentTime, item.dataOraAvvenimento)
  );

  const [trigger] = extendedApiIppica.endpoints.getCorseIppicaInPartenza.useLazyQuery();
  useEffect(() => {
    if (elapsedTime! < 0 && !isTriggering) {
      setTimeIsEnding(true);
      setIsTriggering(true);
      setTimeout(() => {
        trigger(undefined);
        setTimeIsEnding(false);
        setIsTriggering(false);
      }, 4000);
    }
  }, [elapsedTime, isTriggering, trigger]);
  return (
    <>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          <DynamicImage
            className={styles.iconCountry}
            src={IMAGE_COUNTRY}
            alt={''}
            width={16}
            height={16}
            loading={enLoading.lazy}
            decoding="async"
          />
          <span>{item.descrizioneRiunione}</span>
        </div>
        <div className={styles.infoContainer}>
          <div>
            <p className={styles.label}>Corsa</p>
            <span>{item.numeroAvvenimento}</span>
          </div>
          <div>
            <p className={styles.label}>Distanza</p>
            <span>{item.distanza} m</span>
          </div>
          <div>
            <p className={styles.label}>Montepremi</p>
            <span>
              {!item.importoPremio
                ? 'N.D.'
                : convertInCurrencyValueByPrizeInfo(+item.importoPremio, {
                    currencyPrize: item.valutaPremio,
                    nation: item.nazione,
                  })}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.timeStartContainer}>
        {elapsedTime ? (
          <CountdownTimer
            minutes={minutes}
            seconds={seconds}
            className={`${styles.time} ${timeIsEnding ? styles.timeIsEnding : ''}`}
          />
        ) : (
          <span className={styles.time}>{format(new Date(item.dataOraAvvenimento), 'kk:mm')}</span>
        )}
        <Button size="small" className={styles.button} visualizationType="primary" disabled={timeIsEnding}>
          <AnchorLink href={`/ippica/${item.codiceProgramma}-${item.numeroAvvenimento}`} className={styles.link}>
            Scommetti
          </AnchorLink>
        </Button>
      </div>
    </>
  );
};
